import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Container } from '@hivebrite/design-system/Container';
import { useMatchBreakpoint } from '@hivebrite/design-system/Theme';

import Grid, { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';
import Steps from 'hb-react/shared/components/DesignSystem/Steps';
import RequiredExplanation from 'hb-react/shared/components/formik/components/RequiredExplanation';
import useOutboxedFontTheme from 'hb-react/shared/hooks/theme/useOutboxedFontTheme';
import ThemeProvider from 'hb-react/style/ThemeProvider';

const Layout = ({ children, sidebar, navigation = [] }) => {
  const outboxedFontTheme = useOutboxedFontTheme();
  const { requiredExplanation } = navigation.find(({ active }) => active) || {};
  const isMobile = useMatchBreakpoint(['s', 'm']);

  return (
    <Container height="auto" id="event-registration-container">
      <Box display="block" width="100%" mt={4} pb={{ _: 95, l: 80 }}>
        <Grid rowGap={0}>
          <Row>
            <LeftColumn>
              <ThemeProvider
                theme={outboxedFontTheme.themeName}
                fontBrightness={outboxedFontTheme.fontBrightness}
              >
                <Box mb={4} id="steps">
                  <Steps navigation={navigation} />
                </Box>
                {requiredExplanation && !isMobile && (
                  <Box mt={{ _: 0, l: 3 }} mb={4}>
                    <RequiredExplanation />
                  </Box>
                )}
              </ThemeProvider>
            </LeftColumn>
          </Row>
          <Row>
            <LeftColumn>
              {requiredExplanation && isMobile && (
                <ThemeProvider
                  theme={outboxedFontTheme.themeName}
                  fontBrightness={outboxedFontTheme.fontBrightness}
                >
                  <Box mt={{ _: 0, l: 3 }} mb={{ _: 4, l: 0 }}>
                    <RequiredExplanation />
                  </Box>
                </ThemeProvider>
              )}
              <Box display="block">{children}</Box>
            </LeftColumn>
            <Col
              width={({ numCols }) => ({
                _: 1,
                l: 4 / numCols,
                xl: 3 / numCols,
              })}
              offset={({ numCols }) => ({
                _: 0,
                l: 1 / numCols,
              })}
              order={{ _: 1, l: 2 }}
              mb={{ _: 5, l: 0 }}
            >
              {sidebar}
            </Col>
          </Row>
        </Grid>
      </Box>
    </Container>
  );
};

export default Layout;

const LeftColumn = styled(Col).attrs({
  width: ({ numCols }) => ({
    _: 1,
    l: 7 / numCols,
    xl: 6 / numCols,
  }),
  offset: ({ numCols }) => ({
    _: 0,
    xl: 1 / numCols,
  }),
  order: { _: 2, l: 1 },
})``;
